import React from 'react';
import { Handle, Position } from 'reactflow';
import { MessageSquare } from 'lucide-react';

const TriggerNode = ({ data }) => {
  return (
    <div className="bg-purple-100 border-2 border-purple-400 rounded-lg p-4 min-w-[200px]">
      <div className="flex items-center gap-2 mb-2">
        <MessageSquare size={20} className="text-purple-600" />
        <div className="font-semibold text-purple-900">Flow Trigger</div>
      </div>
      <div className="text-sm text-purple-700">
        {data.keywords?.length > 0 ? `Keywords: ${data.keywords.join(', ')}` : 'When user messages'}
      </div>
      <Handle 
        type="source" 
        position={Position.Bottom} 
        className="!w-4 !h-4 !bg-purple-500 !border-2 !border-white"
        style={{ bottom: -8 }}
      />
    </div>
  );
};

export default TriggerNode;
